<template>
  <div class="budgetDeatailDialog">
    <div class="maskDiv" v-if="costTableVisible">
      <div class="costTable">
        <div id="headHeight-class" style="position: sticky;top: 0;z-index: 10;">
          <div class="controlDiv">
            <div style="display:flex;width:10.25rem;justify-content:center;" v-if="showType==1">
              <div style="display:flex;margin-right:2.5rem;align-items:center;">
                <div class="controlDiv_button"  @click="showCostTableHead=true">打开数据汇总板</div>
                <i class="el-icon-arrow-down" style="font-size:18px;color:#ddd;margin-left: 5px;"></i>
              </div>
              <div style="display:flex;align-items:center;">
                <div class="controlDiv_button" @click="showCostTableHead=false">收起数据汇总板</div>
                <i class="el-icon-arrow-up" style="font-size:18px;color:#ddd;margin-left: 5px;"></i>
              </div>
            </div>
            <div class="shareIcon_box">
              <svg-icon style="width: 26px;height: 26px;" :iconClass="'share1'"></svg-icon>
              <div class="saveCostTable" @click="saveBudget()" v-if="showType==1">保存</div>
              <div class="saveCostTable" @click="saveBudget('close')">保存并关闭</div>
              <div class="saveCostTable" style="width: 0.74rem;" @click="closeDialog">关闭</div>
            </div>
          </div>
          <div v-if="showType==1">
            <div class="costTableHead"  v-show="showCostTableHead">
              <div style="display:flex;justify-content: space-between;" >
                <div>
                  <div class="info_box">
                    <div style="margin-left:0.3rem">行程编号：</div>
                    <div style="margin-left:0.15rem;margin-right:0.3rem;">{{chenckBudget.planId}}</div>
                    <div style="border-left:2px solid #bbb;border-right:2px solid #bbb;padding:0 0.3rem;max-width:4.2rem;overflow:hidden;white-space: nowrap;text-overflow: ellipsis;">{{chenckBudget.planName}}</div>
                    <div style="margin-left:0.3rem;">
                      {{dateFormatYMD(chenckBudget.departureDate,"/")}}-{{dateFormatYMD(dateAddDay(chenckBudget.departureDate,chenckBudget.planDay-1).getTime(),"/")}}
                    </div>
                  </div>
                  <div class="costTableHead_body">
                    <div>
                      <div class="appraiser_box">
                        <div>
                          <div class="appraiser_info">
                            <div class="appraiser_info_box">
                              <div class="info_title">座右铭</div>
                              <div class="info_body">性价比永远是开心出行的首要前提</div>
                            </div>
                            <div class="appraiser_info_right">
                              <div class="info_box_right">
                                <div class="info_name">{{planDetail.createName}}</div>
                                <div class="info_avatar"></div>
                              </div>
                              <div class="info_ability">
                                <div>资深定制师</div>
                                <div>共计处理定制需求105件</div>
                              </div>
                            </div>
                          </div>
                          <div class="quotation_box">
                            <el-select v-model="chenckBudget.quotation" style="width:235px">
                              <el-option v-for="(item,index) in planDetail.budgetMains" :key="index" :label="dateFormatYMDHM(item.updateTime,'-')+'报价'" :value="item.id">
                              </el-option>
                            </el-select>
                            <div class="blueButton">收款设置</div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div style="width:7rem;height:2.63rem;margin-left:0.1rem;margin-top:0.2rem;">
                      <div style="display:flex;justify-content:space-between;">
                        <div class="stroke_info_item" style="width:2.24rem;">
                          <div class="distanceInfo">
                            <div>{{chenckBudget.planDay}}</div>
                            <div style="font-size:0.14rem;color: rgba(86, 89, 118, 100);">天数</div>
                          </div>
                          <div class="distanceInfo">
                            <div>{{chenckBudget.countrySize}}</div>
                            <div style="font-size:0.14rem;color: rgba(86, 89, 118, 100);">国家</div>
                          </div>
                          <div class="distanceInfo">
                            <div>{{chenckBudget.citySize}}</div>
                            <div style="font-size:0.14rem;color: rgba(86, 89, 118, 100);">城市</div>
                          </div>
                        </div>
                        <div class="stroke_info_item" style="width:4.61rem;justify-content:space-between;">
                          <div class="distanceInfo">
                            <div style="width:0.75rem;height:0.35rem;background:rgba(219, 78, 26, 0.6);text-align:center;line-height:0.35rem;color:white;font-size:0.16rem;">核算人数</div>
                            <el-input style="width:0.75rem;height:0.34rem;margin-top:0.05rem;" v-model="chenckBudget.useNumber" size="small"/>
                          </div>
                          <div class="distanceInfo">
                            <div style="font-size:0.2rem;color: rgba(255, 98, 0, 100);">
                              {{chenckBudget.useNumber==''?dataObj.totalPrice:parseInt(dataObj.totalPrice/chenckBudget.useNumber)}}￥
                            </div>
                            <div style="font-size: 0.12rem;color: rgba(86, 89, 118, 100);margin-top: 0.05rem;">成本/人</div>
                          </div>
                          <div class="distanceInfo">
                            <div style="font-size:0.2rem;color:rgba(230, 76, 101, 100);">
                              {{chenckBudget.useNumber==''?dataObj.totalPrice:parseInt(dataObj.saleTotalPrice/chenckBudget.useNumber)}}￥
                            </div>
                            <div style="font-size: 0.12rem;color: rgba(86, 89, 118, 100);margin-top:  0.05rem;">报价/人</div>
                          </div>
                          <div class="distanceInfo" style="align-items: flex-start">
                            <div style="font-size:0.2rem;color:rgba(230, 76, 101, 100);">
                              {{chenckBudget.useNumber==''?parseInt(dataObj.saleTotalPrice-dataObj.totalPrice):parseInt((dataObj.saleTotalPrice-dataObj.totalPrice)/chenckBudget.useNumber)}}￥
                            </div>
                            <div style="font-size: 0.12rem;color: rgba(86, 89, 118, 100);margin-top:  0.05rem;line-height:0.16rem;">
                              <span style="font-size: 0.16rem;color: rgba(255, 98, 0, 100);margin-right:0.05rem;">
                                {{parseInt(dataObj.saleTotalPrice)==0&&parseInt(dataObj.saleTotalPrice)==0?0:parseInt(((dataObj.saleTotalPrice-dataObj.totalPrice)/dataObj.saleTotalPrice)*100)}}%</span>利润(率)/人
                              </div>
                          </div>
                        </div>
                      </div>
                      <div style="display:flex;justify-content:space-between;margin-top: 0.12rem;">
                        <div class="price_item">
                          <div class="price_item_box">
                            <div>总成本</div>
                            <div>{{parseInt(dataObj.totalPrice)}}￥</div>
                          </div>
                          <div class="price_item_box">
                            <div>确认中</div>
                            <div>0￥</div>
                          </div>
                          <div class="price_item_box">
                            <div>已确认</div>
                            <div>0￥</div>
                          </div>
                          <div class="price_item_box">
                            <div>待确认</div>
                            <div>0￥</div>
                          </div>
                        </div>
                        <div class="price_item">
                          <div class="price_item_box">
                            <div>总报价</div>
                            <div>{{parseInt(dataObj.saleTotalPrice)}}￥</div>
                          </div>
                          <div class="price_item_box">
                            <div>客户已抢</div>
                            <div>0￥</div>
                          </div>
                          <div class="price_item_box">
                            <div>客户实付</div>
                            <div>0￥</div>
                          </div>
                          <div class="price_item_box">
                            <div>客户待付</div>
                            <div>0￥</div>
                          </div>
                        </div>
                        <div class="price_item">
                          <div class="price_item_box">
                            <div>预计利润</div>
                            <div>{{parseInt(dataObj.saleTotalPrice-dataObj.totalPrice)}}￥</div>
                          </div>
                          <div class="price_item_box">
                            <div>预计利润率</div>
                            <div>{{parseInt(dataObj.totalPrice)==0&&parseInt(dataObj.saleTotalPrice)==0?0:parseInt(((dataObj.saleTotalPrice-dataObj.totalPrice)/dataObj.saleTotalPrice)*100)}}%</div>
                          </div>
                          <div class="price_item_box">
                            <div>实时利润</div>
                            <div>0￥</div>
                          </div>
                          <div class="price_item_box">
                            <div>实时利润率</div>
                            <div>0</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="pieChart" >
                  <div id="pieChart" style="width:3.53rem;height:3.38rem;"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style="display:flex;justify-content:space-between;height: 80px;background: rgb(229, 129, 92);align-items: center;padding: 0 0.2rem;width:14.5rem;border-bottom:3px solid #E65019;">
          <div style="width:7.5rem;position: relative">
            <ul class="order_list">
              <li v-for="(item,index) in orderType" :key="index">
                <div style="line-height:0.35rem;cursor:pointer;" @click="searchOrder(item,index)" v-if="checkedOrderType!=index">{{item.type}}</div>
                <div :style="`position:relative;width:${showType==2?'1.25':'1.75'}rem;`" v-else>
                  <div class="checkedItem_outer" :style="`width:${showType==2?'1':'1.5'}rem`">
                    <div v-if="item.closeButton==false&&showType==1" style="color:rgb(102, 128, 244);width:0.45rem;line-height:0.35rem;
                      cursor:pointer;" @click="restoreInfoByType(item,index,false)">
                      恢复
                    </div>
                    <div :class="item.closeButton?'checkedItem_inside':'checkedItem_inside_close'">{{item.type}}</div>
                    <div v-if="item.closeButton&&showType==1" style="color:black;width:0.45rem;text-align: right;line-height:35px;
                      cursor:pointer;" @click="restoreInfoByType(item,index,true)">
                      关闭
                    </div>
                  </div>
                  <div style="position:absolute;top: -0.11rem;right: 0;" v-if="(item.type!='服务费' && item.type!='税费' && item.type!='其他'&&showType==1)">
                    <div style="width:0.24rem;height:0.19rem;cursor:pointer;"><img src="@/assets/png/1.png" alt="" width="100%" @click="deleteBudgetAll(item)"></div>
                    <div style="width:0.2rem;height:0.19rem;cursor:pointer;margin:0.02rem 0 0.02rem 0.04rem"><img src="@/assets/png/2.png" alt="" width="100%" @click="showprofitVisible"></div>
                    <div style="width:0.24rem;height:0.19rem;cursor:pointer;"><img src="@/assets/png/3.png" alt="" width="100%" ></div>
                  </div>
                  <!-- <div style="position:absolute;top: 0;right: 0;" v-if="item.type!='服务费' && item.type!='税费' && item.type!='其他' && isChangeCostTable">
                    <div style="width:24px;height:19px;cursor:pointer;margin-bottom:2px;"><img src="@/assets/plan/money.png" alt="" width="100%" @click="showprofitVisible"></div>
                    <div style="width:24px;height:19px;cursor:pointer;"><img src="@/assets/plan/3.png" alt="" width="100%" @click="showpersonNumVisible"></div>
                  </div> -->
                  <div style="position:absolute;top: 5px;right: 0;" v-if="(item.type=='服务费' || item.type=='税费' || item.type=='其他')&&showType==1">
                    <div style="width:20px;height:19px;cursor:pointer;margin:2px 0 2px 4px">
                      <img src="@/assets/png/addService.png" alt="" width="100%" @click="addService(item.type)">
                    </div>
                  </div>
                </div>
              </li>
            </ul>

            <el-button
              style="
                position: absolute;
                right: -80px;
                top: 0;
              "
              type="success"
              round
              @click="allCreateOrder"
            >
              预订
            </el-button>
          </div>
          <div style="width:5.2rem;display:flex;justify-content:space-between;">
            <!-- <div class="orderSearchButton">待抢</div>
            <div class="orderSearchButton">确认中</div>
            <div class="orderSearchButton">已确定</div>
            <div class="orderSearchButton">已取消</div>
            <div class="orderSearchButton">已使用</div>
            <div class="orderSearchButton">已评价</div> -->
          </div>
        </div>
        <el-table :span-method="arraySpanMethod" :data="tableList" :summary-method="costTableGetSummaries"
          border show-summary :height="myHeight" style="width: 14.5rem;color:black;padding:0;font-size: 0.12rem;">
          <el-table-column prop="budgetType" label="项目" width="58"></el-table-column>
          <el-table-column label="产品名称" width="120" show-overflow-tooltip>
            <template slot-scope="scope" >
              <input v-model="scope.row.productName" v-if="(scope.row.state==12||scope.row.state==13||scope.row.state==14)&&scope.row.status!=1">
              <div v-else>
                <div class="costTableItem">{{scope.row.productName}}</div>
                <div v-if="scope.row.oldProductName">{{scope.row.oldProductName}}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="说明" width="120" show-overflow-tooltip>
            <template slot-scope="scope">
              <input v-if="(scope.row.state==12||scope.row.state==13||scope.row.state==14)&&scope.row.status!=1" v-model="scope.row.stockDetailObj.productDesc">
              <div v-else class="costTableItem">{{scope.row.stockDetailObj.productDesc}}</div>
            </template>
          </el-table-column>
          <el-table-column label="入住城市" width="50" show-overflow-tooltip prop="cityName">
          </el-table-column>
          <el-table-column label="单位"  width="50">
            <template slot-scope="scope">
              <input v-if="(scope.row.state==12||scope.row.state==13||scope.row.state==14)&&scope.row.status!=1" v-model="scope.row.stockDetailObj.priceList[0].priceCompany">
              <div v-else class="costTableItem">{{scope.row.stockDetailObj.priceList[0].priceCompany}}</div>
            </template>
          </el-table-column>
          <el-table-column label="时长" width="60">
            <template slot-scope="scope">
              <input v-if="(scope.row.state==12||scope.row.state==13||scope.row.state==14)&&scope.row.status!=1" v-model="scope.row.stockDetailObj.priceList[0].useTime">
              <div v-else class="costTableItem">{{scope.row.stockDetailObj.priceList[0].timeDesc?scope.row.stockDetailObj.priceList[0].timeDesc:
                scope.row.stockDetailObj.priceList[0].useTime}}</div>
            </template>
          </el-table-column>
          <el-table-column label="使用日期" width="92">
            <template slot-scope="scope">
              <select v-if="(scope.row.state==12||scope.row.state==13||scope.row.state==14)&&scope.row.status!=1" v-model="scope.row.stayDate" placeholder="请选择" style="width: 95%;">
                <option v-for="(item,index) in chenckBudget.planDayList" :key="index"
                  :label="dateFormatYMD(item.planDate,'-')" :value="dateFormatYMD(item.planDate,'-')"></option>
              </select>
              <div v-else class="costTableItem">{{scope.row.stayDate}}</div>
            </template>
          </el-table-column>
          <el-table-column label="数量" prop="serviceNumber" width="40">
            <template slot-scope="scope">
              <div style="display:flex;justify-content: center;">
                <div class="costTableItem" v-if="scope.row.status==1||showType==2||scope.row.orderBudgetId">{{scope.row.stockNumber}}</div>
                <input v-else v-model="scope.row.stockNumber" @input="changeServiceNumber(scope.row)"/>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="成本(原币)" prop="price" width="72">
            <template slot-scope="scope">
              <div style="display:flex;" v-if="(scope.row.state==12||scope.row.state==13||scope.row.state==14)&&scope.row.status!=1">
                <input v-model="scope.row.stockPrice" style="font-size:12px;width:47%;margin-top: 0.02rem;" @input="changeServiceNumber(scope.row)">
                <currency-autocomplete :obj="scope.row" :styleStr="'width:47%'" @currencySelect="currencySelect($event,scope.row)"></currency-autocomplete>
              </div>
              <div v-else class="costTableItem">{{scope.row.stockPrice+scope.row.currency}}</div>
            </template>
          </el-table-column>
          <el-table-column label="报价(原币)" prop="salePrice" width="72">
            <template slot-scope="scope">
              <div style="display:flex;justify-content: center;" class="qutationDiv">
                <input v-if="scope.row.status!=1&&showType==1" v-model="scope.row.ratio"
                  @input="changeServiceNumber(scope.row)">
                <div v-else class="costTableItem">{{scope.row.ratio}}</div>
                <div>{{scope.row.currency}}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="利润" prop="profit" width="55">
            <template slot-scope="scope">
              <div>
                <div class="costTableItem">{{Number((scope.row.ratio-scope.row.stockPrice).toFixed(2))+scope.row.currency}}</div>
                <!-- <div v-else>
                  <input v-model="scope.row.profit" @input="changeProfit(scope.row)" style="width:70%;font-size:12px;" type="number"/>{{scope.row.currency}}
                </div> -->
              </div>
            </template>
          </el-table-column>
          <el-table-column label="利润率" prop="profitMargin" width="55">
            <template slot-scope="scope">
              <div>
                <div class="costTableItem">{{Number(((scope.row.ratio-scope.row.stockPrice)/scope.row.ratio*100).toFixed(3))+"%"}}</div>
                <!-- <div v-if="scope.row.status==-1">
                  <input v-model="scope.row.profitMargin" type="number" style="width:70%;font-size:12px;"/>%
                </div> -->
              </div>
            </template>
          </el-table-column>
          <el-table-column label="总成本(原币)" width="75">
            <template slot-scope="scope">
              <div class="costTableItem">{{(scope.row.stockPrice*scope.row.stockNumber)+scope.row.currency}}</div>
            </template>
          </el-table-column>
          <el-table-column label="总报价(原币)" width="75">
            <template slot-scope="scope">
              <div class="costTableItem">{{Number((scope.row.ratio*scope.row.stockNumber).toFixed(2))+scope.row.currency}}</div>
            </template>
          </el-table-column>
          <el-table-column width="63">
            <template slot="header">
              <p>汇率</p>
              <p style="transform: scale(0.8);"><a @click="currencyVisible=true" v-if="showType==1" style="color:blue">更新汇率</a></p>
            </template>
            <template slot-scope="scope">
              <div class="costTableItem" v-if="scope.row.status==1||showType==2">{{scope.row.rate}}</div>
              <input v-else v-model="scope.row.rate" @change="changeRate(scope.row)"/>
            </template>
          </el-table-column>
          <el-table-column label="总成本(￥)" width="92">
            <template slot-scope="scope">
              <div class="costTableItem">{{(scope.row.stockPrice*scope.row.stockNumber*scope.row.rate)+"￥"}}<br></div>
            </template>
          </el-table-column>
          <el-table-column label="总报价(￥)" width="92">
            <template slot-scope="scope">
              <div class="costTableItem">{{Number((scope.row.ratio*scope.row.stockNumber*scope.row.rate).toFixed(2))+"￥"}}</div>
            </template>
          </el-table-column>
          <el-table-column label="总利润(￥)" width="80">
            <template slot-scope="scope">
              <div class="costTableItem">{{Number(((scope.row.ratio*scope.row.stockNumber*scope.row.rate)-(scope.row.stockPrice*scope.row.stockNumber*scope.row.rate)).toFixed(2))+"￥"}}</div>
            </template>
          </el-table-column>
          <el-table-column width="110" :key="checkAllFlag">
            <template slot="header" >
              <div style="display:flex;justify-content:space-between;align-items:center;padding: 0 0.1rem;" v-if="showType==1">
                <div>操作</div>
                <div style="text-align:center;">
                  是否<br>
                  <span>加入预算</span>
                </div>
              </div>
              <div v-else>
                <el-checkbox v-model="checkAllFlag" @change="handleCheckAllChange">全选</el-checkbox>
              </div>
            </template>
            <template slot-scope="scope">
              <div style="display: flex;justify-content: space-around;" v-if="showType==1">
                <div style="width:24px; height:24px">
                  <div class="costTableBoutton" v-if="!scope.row.orderBudgetId" @click="singleCreateOrder(scope.row)">抢</div>
                </div>
                <div class="costTableBoutton" v-if="!scope.row.orderBudgetId" @click="deleteBudget(scope.row,scope.$index)">删</div>
                <el-switch @change="changeServiceNumber(scope.row)" v-model="scope.row.status"
                  active-color="#13ce66" inactive-color="#ddd" :active-value="0" :inactive-value="1"></el-switch>
              </div>
              <div v-else>
                <el-checkbox v-model="scope.row.checkFlag" @change="handleCheckAllChangeSingle"></el-checkbox>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <el-dialog :visible.sync="profitVisible" :modal="true" :show-close="false" title="利润率批量调整"
      center :close-on-click-modal="false" width="357px;">
      <div style="display:flex;justify-content:center;">
        <span style="color:#DB4E1A;font-weight:bold;display:inline-block;text-align:center;width:2.1rem;">提示：如果保存此处的数据，<br>您之前录入的产品价格将被覆盖！</span>
      </div>
      <div style="border-bottom:1px solid #ddd;margin:0.15rem 0;"></div>
      <div style="display:flex;justify-content:center;margin-bottom: 0.15rem;">
        <el-radio v-model="addProfitMethod" :label="1">按利润率</el-radio>
        <el-radio v-model="addProfitMethod" :label="2">按报价总价</el-radio>
      </div>
      <div style="display:flex;justify-content:center;align-items:center;padding-top:0.2rem;" v-if="checkedOrderType===0">
        <div style="text-align:center;font-weight:bold;color:#101010;" v-show="addProfitMethod==1">所有项目利润率<br>快速录入</div>
        <div style="text-align:center;font-weight:bold;color:#101010;" v-show="addProfitMethod==2">所有项目总价<br>快速录入</div>
        <el-input v-model="allProfitnNumber" style="width:0.7rem;margin-left:0.2rem;" size="small" @input="changeAllProfit"/><span v-show="addProfitMethod==1">%</span>
      </div>
      <ul style="list-style:none;">
        <li v-for="(item,index) in budgetType" :key="index" style="padding-top:0.2rem;display:flex;justify-content:center">
          <div v-if="checkedOrderType===0||(orderType[checkedOrderType].type==item.type)">
            <el-checkbox style="    width: 1.4rem;" v-model="item.isChecked">
              {{item.type}}
              <span v-show="addProfitMethod==2">{{item.totalPrice}}￥/人&nbsp;&nbsp;</span>
            </el-checkbox>
            <el-input size="small" v-model="item.value" style="width:0.6rem;margin-left: 0.15rem;" @input="item.isChecked=true"/>&nbsp;<span v-show="addProfitMethod==1">%</span>
          </div>
        </li>
      </ul>
      <span slot="footer" class="dialog-footer">
        <el-button @click="profitVisible=false">取 消</el-button>
        <el-button type="primary" @click="saveProfit">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="serviceVisible" :modal="false" :show-close="false" :title="'新增'+budgetTypeName" center :close-on-click-modal="false"
      width="450px" class="serviceAddDialog">
      <div style="display:flex;justify-content:center;margin-top: 0.15rem;">
        <el-radio v-model="addServiceMethod" :label="1">按整数维护</el-radio>
        <el-radio v-model="addServiceMethod" :label="2">按比例维护</el-radio>
      </div>
      <div class="serviceAddDiv" v-if="addServiceMethod===2">
        <div>所有项目比例<br>快速录入</div>
        <label>&nbsp;&nbsp;&nbsp;{{dataObj.saleTotalPrice}}￥</label>
        <el-input v-model="allServiceNumber" style="width:0.7rem;margin-left:0.1rem;" size="small" @input="changeAllService"/>
        <span>%</span>
        <span>&nbsp;&nbsp;&nbsp;{{Number(totalServiceFee.toFixed(2))}}￥</span>
      </div>
      <div v-show="addServiceMethod==1" style="text-align: center;">
        <el-input size="small" v-model="servicePrice" style="width:1.6rem;margin-top: 0.15rem;" placeholder="请输入你要添加的服务费金额"/>&nbsp;
      </div>
      <div v-show="addServiceMethod==2">
        <div v-for="(item,index) in budgetType" :key="index" class="serviceAddDiv">
          <div>
            <el-checkbox v-model="item.isChecked">{{item.type}}</el-checkbox>
          </div>
          <label>&nbsp;&nbsp;{{item.totalPrice}}￥&nbsp;&nbsp;</label>
          <el-input size="small" v-model="item.value" style="width:0.6rem;margin-left: 0.15rem;" @input="changeService(item)"/>&nbsp;
          <span>%</span>
          <span>&nbsp;&nbsp;&nbsp;{{Number((item.totalPrice*(item.value/100)).toFixed(2))}}￥</span>
        </div>
      </div>
      <div v-show="addServiceMethod==2">
        <div style="display:flex;justify-content:center;margin-top: 0.15rem;">
          <el-radio v-model="addServiceDataMethod" :label="1">按整笔生成(生成一笔数据)</el-radio>
          <el-radio v-model="addServiceDataMethod" :label="2">按项目生成(按项目生成多笔数据)</el-radio>
        </div> 
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="serviceVisible=false">取 消</el-button>
        <el-button type="primary" @click="saveService">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="currencyVisible" :modal="true" :show-close="false" title="汇率批量调整"
      center :close-on-click-modal="false" width="357px;">
      <div style="display:flex;justify-content:center;">
        <span style="color:#DB4E1A;font-weight:bold;display:inline-block;text-align:center;width:2.1rem;">提示：如果保存此处的数据，<br>您之前录入的汇率将被覆盖！</span>
      </div>
      <div style="border-bottom:1px solid #ddd;margin:0.15rem 0;"></div>
      <div v-if="currencies.length>0" style="text-align: center;">
        <a @click="toOldRate()" style="color:blue;">更新为系统最新汇率</a>
        <div style="text-align:center;font-weight:bold;color:#101010;margin-top: 0.1rem;">汇率快速录入</div>
        <ul style="list-style:none;">
          <li v-for="(item,index) in currencies" :key="index" style="padding-top:0.2rem;display:flex;justify-content:center">
            <div>
              <el-checkbox style="width: 1.4rem;" v-model="item.isChecked">
                {{item.code}}
              </el-checkbox>
              <el-input size="small" v-model="item.value" style="width:0.6rem;margin-left: 0.15rem;" @input="item.isChecked=true"/>
            </div>
          </li>
        </ul>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="currencyVisible=false">取 消</el-button>
        <el-button type="primary" @click="saveCurrency">确 定</el-button>
      </span>
    </el-dialog>
    <createPreOrder ref="orderPre" id="createPreOrder"></createPreOrder>
  </div>
</template>

<script>
import PlanApi from '@/components/Api/PlanApi.js'
import {refresh} from "../../js/function"
import CurrencyAutocomplete from '../../../common/currencyAutocomplete.vue';
import {budgetMixin} from "./../mixin/budgetMixin"
import createPreOrder from "@/views/plan/leftMoudle/dialog/createPreOrder.vue";
export default {
  components:{createPreOrder, CurrencyAutocomplete},
  mixins:[budgetMixin],
  data(){
    return{
      costTableVisible:false,
      showCostTableHead:true,
      myHeight:0,
      tableList:[],
      orderType:[],
      checkedOrderType:0,
      costIdArr:[],
      allTableList:[],
      profitVisible:false,
      allProfitnNumber:'',
      budgetType:[],
      changeTableList:[],
      budgetMainId:'',
      addProfitMethod:1,
      currencies:[],
      serviceVisible:false,
      budgetTypeName:'',
      addServiceMethod:1,
      allServiceNumber:null,
      totalServiceFee:0,
      addServiceDataMethod:1,
      showType:1,
      checkAllFlag:false,
      currencyVisible:false,
      servicePrice:null,
    }
  },
  props:{
    chenckBudget:{
      type:Object,
      default:()=>{return{}}
    },
    planDetail:{
      type:Object,
      default:()=>{return{}}
    }
  },
  methods:{
    allCreateOrder() {
      let arr = this.tableList.filter(x => x.status === 0 && !x.orderBudgetId)
      console.log('allCreateOrder',arr,this.tableList)
      let budgetIds = []
      arr.forEach(data => {
        // if (data.linkBudgetIds && data.linkBudgetIds.length > 0) {
        //   budgetIds.push(...data.linkBudgetIds)
        // } else {
        //   budgetIds.push(...data.budgetIds)
        // }
        budgetIds.push(data.id)
      })
      if(budgetIds.length === 0) {
        this.$message({type:"warning",message:"商品全部已定！"})
          return 
      }
      this.$refs.orderPre.init([...budgetIds,-1], 0)
    },
    // 单个"订"下订单
    singleCreateOrder(data) {
      console.log("singleCreateOrder",data)
      let budgetIds = []
      // if (data.linkBudgetIds && data.linkBudgetIds.length > 0) {
      //   budgetIds.push(...data.linkBudgetIds)
      // } else {
      //   budgetIds.push(...data.budgetIds)
      // }
      budgetIds.push(data.id)
      this.$refs.orderPre.init([...budgetIds,-1], 0)
    },
    saveCurrency(){
      this.currencies.forEach(e=>{
        if(e.isChecked){
          this.tableList.forEach(ee=>{
            if(ee.currency==e.code){
              this.$set(ee,'rate',e.value)
              this.addDataToChangeList(ee)
            }
          })
        }
      })
      this.currencyVisible = false
      this.getCostTableTotal()
      this.updateTopPrice()
    },
    handleCheckAllChange(){
      this.tableList.forEach(ee=>{
        this.$set(ee,'checkFlag',this.checkAllFlag)
      })
    },
    handleCheckAllChangeSingle(){

    },
    deleteBudgetAll(item){
      this.$confirm('您确认删除该数据吗？', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        new PlanApi('plan').budgetEmpty({budgetMainId:this.chenckBudget.id,state:item.state}).then(res => {
          if (res.status == 200) {
            this.$message({type:"success",message:"删除成功"})
            this.tableList.forEach(e=>{
              if(item.state==-1||e.state==item.state){
                this.tableList.splice(index,1)
                if(e.id){
                  this.allTableList.splice(this.allTableList.findIndex(e=>e.id==item.id),1)
                }else{
                  this.allTableList.splice(this.allTableList.findIndex(e=>e.addIndex==item.addIndex),1)
                }
              }
            })
            this.tableList = this.mergeTableRow(this.tableList,['productName',"budgetType"])
            this.getCostTableTotal()
            this.updateTopPrice()
          }else{
            this.$message({type:"error",message:res.statusText})
          }
        })
      }).catch((err) => {})
    },
    deleteBudget(item,index){
      if(item.id){
        this.$confirm('您确认删除该数据吗？', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          new PlanApi('plan').budgetDelete({budgetMainId:[this.chenckBudget.id],budgetDetailIds:[item.id],budgetIds:[item.budgetId]}).then(res => {
            if (res.status == 200) {
              this.$message({type:"success",message:"删除成功"})
              this.tableList.splice(index,1)
              this.tableList = this.mergeTableRow(this.tableList,['productName',"budgetType"])
              this.allTableList.splice(this.allTableList.findIndex(e=>e.id==item.id),1)
              this.getCostTableTotal()
              this.updateTopPrice()
            }else{
              this.$message({type:"error",message:res.statusText})
            }
          })
        }).catch((err) => {})
      }else{
        this.tableList.splice(index,1)
        this.allTableList.splice(this.allTableList.findIndex(e=>e.addIndex==item.addIndex),1)
        this.getCostTableTotal()
        this.updateTopPrice()
      }
    },
    changeAllProfit(){
      this.budgetType.forEach(item=>{
        item.value = this.allProfitnNumber
        item.isChecked = true
      })
    },
    changeService(item){
      item.isChecked=true
      var serviceTotalPrice = 0
      this.budgetType.forEach(item=>{
        serviceTotalPrice+=item.totalPrice*(item.value/100)
      })
      this.totalServiceFee = serviceTotalPrice
      this.allServiceNumber = Number(((serviceTotalPrice/this.dataObj.saleTotalPrice)*100).toFixed(2))
    },
    changeAllService(){
      this.totalServiceFee = this.dataObj.saleTotalPrice*(this.allServiceNumber/100)
      this.budgetType.forEach(item=>{
        if(item.totalPrice>0){
          item.value = this.allServiceNumber
          item.isChecked = true
        }
      })
    },
    toOldRate(){
      this.tableList.forEach(ee=>{
        this.$set(ee,'rate',ee.oldRate)
        this.addDataToChangeList(ee)
      })
      this.currencyVisible= false
    },
    saveProfit(){
      this.budgetType.forEach(e=>{
        if(e.isChecked){
          if(this.addProfitMethod==1){
            this.tableList.forEach(ee=>{
              if(ee.state==e.state){
                if(this.addProfitMethod==1){
                  ee.ratio = ee.stockPrice/(1-(e.value*0.01))
                }
                this.addDataToChangeList(ee);
              }
            })
          }else{
            var totalPrice = (e.value-e.totalPrice)*this.chenckBudget.useNumber
            var arr = this.tableList.filter(ee=>ee.state==e.state);
            var averagePrice = totalPrice/arr.length
            var truePrice=0;
            arr.forEach(ee=>{
              var price = Number((averagePrice/ee.stockNumber/ee.rate).toFixed(2))
              ee.ratio = ee.stockPrice+price
              truePrice+=price*ee.stockNumber*ee.rate
              this.addDataToChangeList(ee);
            })
            if(truePrice>totalPrice){
              arr[0].ratio = (arr[0].ratio-((truePrice-totalPrice)/arr[0].rate/arr[0].stockNumber).toFixed(3)).toFixed(3)
            }
            if(truePrice<totalPrice){
              arr[0].ratio = (arr[0].ratio+((totalPrice-truePrice)/arr[0].rate/arr[0].stockNumber).toFixed(3)).toFixed(3)
            }
          }
        }
      })
      this.profitVisible = false
      this.getCostTableTotal()
      this.updateTopPrice()
    },
    saveService(){
      if(this.addServiceMethod==1){
        this.addServiceObj(this.budgetTypeName,"￥","整团"+this.budgetTypeName,this.servicePrice)
      }else{
        if(this.addServiceDataMethod==1){
          this.addServiceObj(this.budgetTypeName,"￥","整团"+this.budgetTypeName,this.totalServiceFee,-1,this.allServiceNumber,'按照'+this.allServiceNumber+"%核算")
        }else{
          this.budgetType.forEach(item=>{
            if(item.isChecked){
              this.addServiceObj(this.budgetTypeName,"￥",item.type+this.budgetTypeName,item.totalPrice*(item.value/100),item.state,item.value,'按照'+item.value+"%核算")
            }
          })
        }
      }
      new PlanApi('plan').updateBudgetMain({
        id:this.chenckBudget.id,
        servicePercentage:this.budgetTypeName=='服务费'?this.allServiceNumber:null,
        taxPercentage:this.budgetTypeName!='服务费'?this.allServiceNumber:null
      }).then(res => {})
      this.serviceVisible=false
    },
    addServiceObj(budgetType,currency,productName,ratio,state,proportion,productDesc){
      var obj = {
        currency:currency?currency:'',
        productName:productName?productName:'',
        ratio:ratio?ratio:'',
        rate:currency?1:'',
        state:budgetType=='服务费'?12:budgetType=='税费'?13:14,
        stayDate:'',
        stockNumber:ratio?1:'',
        stockPrice:0,
        status:0,
        budgetType:budgetType,
        stockDetailObj:{
          productDesc:productDesc?productDesc:'',
          priceList:[{
            priceCompany:'',
            useTime:'',
            timeDesc:''
          }]
        },
        addIndex:this.allTableList.length+1,
        stateType:proportion?state:null,
        proportion:proportion?proportion:null,
      }
      this.tableList.push(obj)
      this.allTableList.push(obj)
      this.getCostTableTotal()
      this.updateTopPrice()
    },
    addService(budgetType){
      if(budgetType=='服务费'||budgetType=='税费'){
        this.budgetTypeName = budgetType
        this.serviceVisible=true
        this.allServiceNumber=null
        this.servicePrice=null
        this.budgetType.forEach(e=>{
          var totalPrice = 0;
          e.value = ''
          e.isChecked=false
          this.allTableList.forEach(ee=>{
            if(ee.state==e.state){
              totalPrice+=ee.ratio*ee.rate*ee.stockNumber
            }
          })
          this.$set(e,'totalPrice',Number(totalPrice.toFixed(2)));
        })
      }else{
        this.addServiceObj(budgetType)
      }
    },
    updateTopPrice(){
      var price8=0
      var price7=0
      this.allTableList.forEach((item,index)=>{
        if(item.status!=1){
          price8+=item.stockPrice*item.rate*item.stockNumber
          price7+=item.ratio*item.rate*item.stockNumber
        }
      })
      this.dataObj.totalPrice= price8.toFixed(2)
      this.dataObj.saleTotalPrice = price7.toFixed(2)
    },
    addDataToChangeList(val){
      if(val.id&&this.changeTableList.filter(c=>c.id==val.id).length==0){
        this.changeTableList.push(val)
      }
    },
    changeRate(item){
      if(item.oldRate>item.rate){
        item.rate = item.oldRate
        this.$message({type:"error",message:"更改汇率不能小于原汇率"})
      }else{
        this.changeServiceNumber(item)
      }
    },
    currencySelect(rateItem,item){
      item.rate = rateItem.payeeRate
      this.changeServiceNumber(item)
    },
    changeServiceNumber(val){
      this.addDataToChangeList(val)
      this.getCostTableTotal()
      this.updateTopPrice()
    },
    saveBudget(type){
      if(this.showType==2){
        this.$emit("chooseProduct",this.tableList)
        this.costTableVisible = false;
      }else{
        this.allTableList.forEach(e=>{
          if(!e.id){
            this.changeTableList.push(e);
          }
        })
        this.changeTableList.forEach(e=>{
          e.stockDetail = JSON.stringify(e.stockDetailObj)
        })
        new PlanApi('plan').updateBudgetDetail({
          id:this.chenckBudget.id,
          useNumber:this.chenckBudget.useNumber,
          details:this.changeTableList
        }).then(res => {
          if (res.status == 200) {
            this.$message({type:"success",message:"保存成功"})
            res.data.addCitySize=0
            this.budgetMainId = res.data.budgetMainId
            this.changeTableList = []
            if(type=='close'){
              this.closeDialog()
            }
          }else{
            this.$message({type:"error",message:res.statusText})
          }
        })
      }
    },
    closeDialog(){
      this.costTableVisible = false;
      if(this.budgetMainId!=''){
        refresh(this.budgetMainId,this.$store.state.planId,this.$store.state.budgetMainId,'')
      }
    },
    searchOrder(item, index) {
      this.checkedOrderType = index;
      this.tableList = [];
      if (item.type == "全部") {
        this.tableList = this.allTableList;
      } else {
        this.allTableList.forEach((value, index) => {
          if (value.budgetType == item.type) {
            this.tableList.push(value);
          }
        });
      }
      this.getCostTableTotal();
    },
    showprofitVisible() {
      this.profitVisible = true;
      this.currencies.forEach(e=>{
        e.value = ''
        e.isChecked=false
      })
      this.budgetType.forEach(e=>{
        var totalPrice = 0;
        e.value = ''
        e.isChecked=false
        this.tableList.forEach(ee=>{
          if(ee.state==e.state){
            totalPrice+=ee.stockPrice*ee.rate*ee.stockNumber
          }
        })
        this.$set(e,'totalPrice',(totalPrice/this.chenckBudget.useNumber).toFixed(2));
      })
    },
    restoreInfoByType(item,index,flag){

    },
    openDialog(showType){
      this.costTableVisible = true
      this.checkedOrderType = 0
      if(showType==2) this.showType=showType
      else this.showType=1
      this.$set(this.chenckBudget,'quotation',this.dateFormatYMDHM(this.chenckBudget.updateTime,'-')+'报价')
      new PlanApi('plan').budgetDetailList({budgetMainId:this.chenckBudget.id,showSpot:0}).then(res => {
        if (res.status == 200) {
          this.dataObj = res.data
          this.tableList = []
          this.orderType = [{type:'全部',closeButton:true,state:-1}]
          this.budgetType=[]
          this.currencies=[]
          var stateList =[... new Set(res.data.budgetList.map(item=>item.state))]
          var currencies =[... new Set(res.data.budgetList.map(item=>item.currency))]
          currencies.forEach(item=>{
            if(item!=''&&item!='￥')
            this.currencies.push({
              code:item,
              isChecked:false,
              value:null,
            })
          })
          stateList.forEach(item=>{
            this.orderType.push({
              type:this.stockTypeMap[item]?this.stockTypeMap[item].typeName:'',
              closeButton:true,
              state:item
            })
            this.budgetType.push({
              type:this.stockTypeMap[item]?this.stockTypeMap[item].typeName:'',
              isChecked:false,
              value:null,
              state:item,
            })
          })
          res.data.budgetList.forEach(ee=>{
            if(ee.stockDetail!=''){
              ee.stockDetailObj = JSON.parse(ee.stockDetail)
            }else{
              ee.stockDetailObj = {
                productDesc:'',
                priceList:[{
                  priceCompany:'',
                  useTime:'',
                  timeDesc:''
                }]
              }
            }
            ee.budgetType = this.stockTypeMap[ee.state].typeName
            this.tableList.push(ee)
            this.$set(ee,'stayDate',this.dateFormatYMD(ee.stayDate,"-"))
          })
          this.getCostTableTotal()
          this.countHeight()
          if(this.showType==1) this.pieChart()
          if(stateList.indexOf(12)==-1) this.orderType.push({type:'服务费',closeButton:true,state:12})
          if(stateList.indexOf(13)==-1) this.orderType.push({type:'税费',closeButton:true,state:13})
          if(stateList.indexOf(14)==-1) this.orderType.push({type:'其他',closeButton:true,state:14})
          this.tableList = this.mergeTableRow(this.tableList,['productName',"budgetType"])
          this.allTableList = this.tableList
        }else{
          this.$message({type:"error",message:res.statusText})
        }
      })
    },
    mergeTableRow(data, merge) {
      if (!merge || merge.length === 0) {
        return data
      }
      merge.forEach((m,index1) => {
        const mList = {}
        data = data.map((v, index) => {
          const rowVal = v[m]
          if (mList[rowVal] && mList[rowVal].newIndex === index) {
            mList[rowVal]['num']++
            mList[rowVal]['newIndex']++
            data[mList[rowVal]['index']][m + '-span'].rowspan++
            if(index1==0&&v.state===0&&data[mList[rowVal]['index']][m + '-span'].rowspan>1){
              this.$set(data[mList[rowVal]['index']],'oldProductName',"共"+data[mList[rowVal]['index']][m + '-span'].rowspan+"晚")
            }
            if(index1==0&&(v.state===3||v.state==5)&&data[mList[rowVal]['index']][m + '-span'].rowspan>1){
              this.$set(data[mList[rowVal]['index']],'oldProductName',"共"+data[mList[rowVal]['index']][m + '-span'].rowspan+"天")
            }
            v[m + '-span'] = {
              rowspan: 0,
              colspan: 0
            }
          } else {
            mList[rowVal] = { num: 1, index: index, newIndex: index + 1 }
            v[m + '-span'] = {
              rowspan: 1,
              colspan: 1
            }
          }
          return v
        })
      })
      return data
    },
    arraySpanMethod({ row, column, rowIndex, columnIndex }){
      if(columnIndex===1){
        return row['productName-span']
      }
      if(columnIndex===0){
        return row['budgetType-span']
      }
    },
    costTableGetSummaries({ columns, data }){
      return [
        "合计",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        this.costIdArr["price1"],
        this.costIdArr["price2"],
        this.costIdArr["price3"],
        this.costIdArr["price4"],
        this.costIdArr["price5"],
        this.costIdArr["price6"],
        "",
        this.costIdArr["price7"] +"￥"+(this.chenckBudget.useNumber==""?"":"\r\n"+(this.costIdArr["price7"]/this.chenckBudget.useNumber).toFixed(2)+"￥/人"),
        this.costIdArr["price8"] +"￥"+(this.chenckBudget.useNumber==""?"":"\r\n"+(this.costIdArr["price8"]/this.chenckBudget.useNumber).toFixed(2)+"￥/人"),
        this.costIdArr["price9"] +"￥",
        "",
      ];
    },
    getCostTableTotal(){
      var price1=''
      var price2=''
      var price3=''
      var price4=''
      var price5=''
      var price6=''
      var price7=0
      var price8=0
      var arr=[]
      this.tableList.forEach((item,index)=>{
        if(item.status!==1){
          arr.push(item.currency)
          price7+=item.stockPrice*item.rate*item.stockNumber
          price8+=item.ratio*item.rate*item.stockNumber
        }
      })
      arr=arr.filter(function (element, index, self) {
        return self.indexOf(element) === index;
      })
      var obj={price1:{},price2:{},price3:{},price4:{},price5:{},price6:{}}
      arr.forEach((item,index)=>{
        for(var i in obj){
          this.$set(obj[i],item,0)
          this.tableList.forEach((itemTwo,indexTwo)=>{
            if(itemTwo.status!==1){
              if(itemTwo.currency==item){
                if(i=='price1'){
                  obj[i][item]+=itemTwo.stockPrice
                }
                if(i=='price2'){
                  obj[i][item]+=Number(itemTwo.ratio)
                }
                if(i=='price3'){
                  obj[i][item]=obj['price2'][item]-obj['price1'][item]
                }
                if(i=='price4'){
                  obj[i][item]=((obj['price3'][item]/obj['price2'][item])*100).toFixed(3)
                }
                if(i=='price5'){
                  obj[i][item]+=itemTwo.stockPrice*itemTwo.stockNumber
                }
                if(i=='price6'){
                  obj[i][item]+=itemTwo.ratio*itemTwo.stockNumber
                }
              }
            }
          })
        }
      })
      for(var i in obj){
        for(var j in obj[i]){
          if(i=='price1'){
            price1+=obj[i][j]+j+'\n'
          }
          if(i=='price2'){
            price2+=Number((obj[i][j]).toFixed(2))+j+'\n'
          }
          if(i=='price3'){
            price3+=Number((obj[i][j]).toFixed(2))+j+'\n'
          }
          if(i=='price4'){
            price4+=obj[i][j]+'%'+'\n'
          }
          if(i=='price5'){
            price5+=obj[i][j]+j+'\n'
          }
          if(i=='price6'){
            price6+=Number((obj[i][j]).toFixed(2))+j+'\n'+(obj[i][j]/this.chenckBudget.useNumber).toFixed(2)+j+'/人'+'\n'
          }
        }
      }
      this.$set(this.costIdArr,'price1',price1)
      this.$set(this.costIdArr,'price2',price2)
      this.$set(this.costIdArr,'price3',price3)
      this.$set(this.costIdArr,'price4',price4)
      this.$set(this.costIdArr,'price5',price5)
      this.$set(this.costIdArr,'price6',price6)
      this.$set(this.costIdArr,'price7',price7.toFixed(2))
      this.$set(this.costIdArr,'price8',price8.toFixed(2))
      this.$set(this.costIdArr,'price9',(price8-price7).toFixed(2))
    },
    countHeight(){
      this.$nextTick(()=>{
        let hh = document.body.clientHeight
        var div = document.getElementById('headHeight-class');
        this.myHeight = hh - div.clientHeight-80
      })
    }
  },
  watch: {
    showCostTableHead(){
      this.countHeight()
    }
  }
}
</script>
<style>


</style>
<style lang="scss" scoped>
.budgetDeatailDialog{
  /deep/ .el-dialog__wrapper{
    z-index: 3000 !important;
  }
}
.serviceAddDialog{
  .serviceAddDiv{
    display:flex;
    align-items:center;
    padding-top:0.2rem;
    >div{
      text-align:center;
      font-weight:bold;
      color:#101010;
      width: 100px;
    }
    >label{
      width: 100px;
    }
  }
}
.maskDiv{
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background:rgba(0,0,0,0.5);
  z-index:1000;
}
.costTable{
  position: fixed;
  left: 50%;
  transform: translate(-50%, 0);
  z-index: 2017;
  height: 100%;
  background: white;
  overflow: hidden;
  padding-bottom: 0.2rem;
  .controlDiv{
    width: 14.5rem;
    background: #E65019;
    height: 0.5rem;
    display: flex;
    padding: 0.1rem 0.2rem;
    justify-content: space-between;
    .controlDiv_button{
      font-size: 0.18rem;
      color: white;
      width: 1.5rem;
      height: 0.3rem;
      line-height: 0.3rem;
      border-bottom: 1px solid #ffffff;
      text-align: center;
      cursor: pointer;
      font-family: SourceHanSansSC-regular;
    }
    .shareIcon_box{
      width: 3.63rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .saveCostTable{
        color: #505559;
        border-radius: 5px;
        text-align: center;
        height: 0.3rem;
        line-height: 0.3rem;
        width: 1.05rem;
        background: white;
        cursor: pointer;
      }
    }
  }
  .costTableHead{
    width: 14.5rem;
    height: 3.83rem;
    background: #E65019;
    padding: 0.1rem 0.2rem;
    .info_box{
      width: 10.25rem;
      height: 0.62rem;
      color: rgba(80,85,89,0.7);
      font-size: 0.2rem;
      background: white;
      border-radius: 5px;
      display: flex;
      align-items: center;
    }
    .costTableHead_body{
      display: flex;
      .appraiser_box{
        width: 3.16rem;
        height: 1.91rem;
        border-radius: 5px;
        background: white;
        margin-top: 0.2rem;
        .appraiser_info{
          width: 3.16rem;
          height: 1.91rem;
          display: flex;
          align-items: center;
          .appraiser_info_box{
            width: 1.1rem;
            height: 1.26rem;
            margin-left: 0.3rem;
            padding: 0.2rem 0.2rem 0.2rem 0;
            border-right: 2px solid #ddd;
            color: #e38c09;
            .info_title{
              font-size: 0.16rem;
            }
            .info_body{
              width: 0.78rem;
              height: 0.67rem;
              font-size: 0.13rem;
              line-height: 0.24rem;
              margin-top: 0.1rem;
            }
          }
          .appraiser_info_right{
            padding: 0.05rem 0 0.2rem 0.2rem;
            height: 1.26rem;
            width: 1.96rem;
            .info_box_right{
              display: flex;
              align-items: center;
              .info_name{
                font-weight: bold;
                font-size: 0.16rem;
                color: black;
              }
              .info_avatar{
                width: 0.5rem;
                height: 0.5rem;
                border-radius: 50%;
                background: url('/static/img/head.cf1e34c.jpg');
                background-size: cover;
                margin-left: 0.3rem;
              }
            }
            .info_ability{
              font-size: 0.13rem;
              color: #101010;
              line-height: 0.2rem;
              margin-top: 0.1rem;
            }
          }
        }
        .quotation_box{
          width: 3.17rem;
          height: 0.62rem;
          border-radius: 5px;
          background: white;
          display: flex;
          align-items: center;
          margin-top: 0.1rem;
          /deep/ .el-input__inner {
            border: 1px solid white;
            font-size: 0.18rem;
          }
            width: 100%;
          .blueButton{
            width: 0.69rem;
            height: 0.25rem;
            font-size: 0.13rem;
            font-weight: bold;
            color: white;
            text-align: center;
            line-height: 0.25rem;
            background: #02A0C6;
            border-radius: 2px;
            margin-left: 0.08rem;
            cursor: pointer;
          }
        }
      }
      .stroke_info_item{
        height: 0.94rem;
        background: white;
        display: flex;
        border-radius: 5px;
        align-items: center;
        justify-content: space-around;
        font-size: 0.38rem;
        padding: 0 0.15rem;
        font-family: SourceHanSansSC-regular;
        color: #565976;
        .distanceInfo{
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: space-around;
        }
      }
      .price_item{
        width: 2.24rem;
        height: 1.57rem;
        background: white;
        border-radius: 5px;
        padding: 0.1rem 0.2rem;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .price_item_box{
          display: flex;
          justify-content: space-between;
          align-items: center;
          >div:first-child{
            font-size: 0.16rem;
          }
          >div:last-child{
            font-size: 0.22rem;
            font-weight: bold;
          }
        }
        >div:first-child{
          color: #ff6200;
        }
        >div:nth-child(2){
          color: #67c23a;
        }
        >div:nth-child(3){
          color: #ff1744;
        }
        >div:last-child{
          color: #1390ca;
        }
      }
    }
    .pieChart{
      width: 3.63rem;
      height: 3.45rem;
      background: white;
      border-radius: 5px;
      display: flex;
      align-items: center;
      flex-direction: column;
      padding: 0.05rem;
    }
  }
  .costTableItem{
    padding: 0 0.05rem;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .costTableBoutton{
    width: 0.24rem;
    height: 0.24rem;
    border-radius: 50%;
    font-size: 0.18rem;
    color: #D81B43;
    font-weight: bold;
    box-shadow: 0px 2px 12px 0px rgba(0, 0,0 ,0.4);
    text-align: center;
    line-height: 0.24rem;
    cursor: pointer;
  }
  .order_list{
    display: flex;
    justify-content: space-between;
    font-size: 0.18rem;
    color: white;
    .checkedItem_outer{
      height: 0.35rem;
      background: white;
      border-radius: 25px;
      display: flex;
      align-items: center;
      justify-content: center;
      .checkedItem_inside{
        width: 0.8rem;
        height: 0.25rem;
        background: #6680F4;
        text-align: center;
        border-radius: 20px;
        color: white;
        line-height: 0.25rem;
      }
    }
  }
}
</style>
<style>
.maskDiv .el-table td,
.el-table th {
  text-align: center !important;
}
.maskDiv .el-table{
  overflow:visible !important;
}
.maskDiv .el-table .cell{
  padding: 0 !important;
  word-break: normal;
}
.maskDiv .el-table .cell input{
  width: 70%;
  height: 0.18rem;
  text-align: center;
  border: none;
  border-bottom: 1px solid #E5815C;
  padding-bottom: 0.05rem;
  font-size: 0.12rem;
}
.maskDiv .el-table .cell .qutationDiv input{
  color: red;
}
.maskDiv .el-table .cell .el-input__inner{
  text-align: center;
  padding: 0 !important;
}
#createPreOrder {
  z-index: 3001 !important;
}
</style>
